
import React, { useState } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';

export default function EnviosAccordion({ children }) {
    const [activeIndex, setActiveIndex] = useState(null);

    return (
        <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} multiple>
            {children}
        </Accordion>
    );
}
